import { createRouter, createWebHistory } from 'vue-router';
import AdminLayout from '../components/AdminLayout.vue';
import { useAuthStore } from '../stores/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      component: AdminLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('../views/Home.vue')
        },
        {
          path: 'networks',
          name: 'networks',
          component: () => import('../views/Networks.vue')
        },
        {
          path: 'tokens',
          name: 'tokens',
          component: () => import('../views/Tokens.vue')
        },
        {
          path: 'pack-credits',
          name: 'pack-credits',
          component: () => import('../views/PackCredits.vue')
        },
        {
          path: 'users',
          name: 'users',
          component: () => import('../views/Users.vue')
        },
        {
          path: 'users/:id',
          name: 'user-detail',
          component: () => import('../views/UserDetail.vue')
        },
        {
          path: 'alerts',
          name: 'alerts',
          component: () => import('../views/Alerts.vue')
        },
        {
          path: 'transactions',
          name: 'transactions',
          component: () => import('../views/Transactions.vue')
        },
        {
          path: 'invoices',
          name: 'invoices',
          component: () => import('../views/Invoices.vue')
        }
      ]
    }
  ]
});

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore();
  
  // Проверяем авторизацию перед каждым переходом
  authStore.checkAuth();

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !authStore.isAuthenticated) {
    // Сохраняем путь, куда пользователь хотел попасть
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    // Если уже авторизован, перенаправляем на главную
    next('/');
  } else {
    next();
  }
});

export default router;

